<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H12.8027C12.4513 21.3926 12.2034 20.7179 12.083 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4H13V9H19V13.083C19.7179 13.2034 20.3926 13.4513 21 13.8027V9C21 5.13401 17.866 2 14 2H6ZM12.083 18C12.2034 17.2821 12.4513 16.6074 12.8027 16H7V18H12.083ZM14.6822 14C15.3686 13.5436 16.1543 13.2248 17 13.083V12H7V14H14.6822ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002ZM11 10H7V8H11V10ZM17.015 22.9849V19.9699H14V17.9999H17.015V14.9849H18.985V17.9999H22V19.9699H18.985V22.9849H17.015Z"
  />
</template>
